import React from 'react';
import './styles.scss';
import { Accordion } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { ISoundtrack } from '../../../@types/ISoundtrack';
import { ISource } from '../../../@types/ISource';
import AudioControl from './AudioControl';
import AudioInfo from './AudioInfo';
import ToggleMenu from './ToggleMenu';
import { checkIfCardCollapsible } from '../viewsHelper';
import { IUser } from '../../../@types/IUser';

interface IProps {
  medium: ISoundtrack;
  eventKey: string;
  activeEventKey: null | string;
  mediumSetter: (medium: ISoundtrack) => void;
  onRemoveMedium?: (medium: ISoundtrack) => void;
  onReportMedium?: (medium: ISoundtrack) => void;
  onRemoveFromQueue?: (medium: ISoundtrack) => void;
  onAddToQueue?: (medium: ISoundtrack) => void;
  source: ISource;
  sourceOwner: IUser;
  showActions?: boolean;
}

function MediaFlatItem(props: IProps) {
  const { current_user } = useSelector(({ current_user }: any) => ({
    current_user,
  }));

  return (
    <Accordion.Toggle
      eventKey={props.eventKey}
      className="media media-flat-item"
      as="div"
    >
      <AudioControl medium={props.medium} source={props.source} />
      <div className="media-body">
        <AudioInfo
          eventKey={props.eventKey}
          activeEventKey={
            checkIfCardCollapsible(props.medium)
              ? props.activeEventKey
              : props.eventKey
          }
          medium={props.medium}
          showActions={props.showActions}
          mediumSetter={props.mediumSetter}
        />
        {current_user && (
          <ToggleMenu
            medium={props.medium}
            source={props.source}
            sourceOwner={props.sourceOwner}
            onRemoveMedium={props.onRemoveMedium}
            onReportMedium={props.onReportMedium}
            onRemoveFromQueue={props.onRemoveFromQueue}
            onAddToQueue={props.onAddToQueue}
          />
        )}
      </div>
    </Accordion.Toggle>
  );
}

export default MediaFlatItem;
